import '../scss/style.scss';

const filterModalBtn = document.querySelector('.catalog__filter-modal'),
    filterRoot = document.querySelector('.catalog-filter');

if (filterModalBtn && filterRoot) {
    filterModalBtn.addEventListener('click', () => {
        filterRoot.hidden = false;

        void filterRoot.offsetHeight;

        filterRoot.classList.remove('catalog-filter--closing');
    });
}

const filterViewList = document.querySelectorAll(`.catalog__filter-view-item`);

filterViewList.forEach(element => {
    element.addEventListener("click", function(e) {
        e.preventDefault();

        filterViewList.forEach(element => {
            element.classList.remove("active");
        });

        this.classList.add("active");

        const catalogListRow = document.querySelector(`.catalog__list__row`);
        catalogListRow.className = catalogListRow.className.replace(/\bcatalog__list__row-\S+/g, '').trim();
        catalogListRow.classList.add(`catalog__list__row-${this.dataset.view}`);
        
        document.body.className = document.body.className.replace(/\bcatalog_style--\S+/g, '').trim();
        document.body.classList.add(`catalog_style--${this.dataset.view}`);

        document.cookie = `catalog_view=${this.dataset.view}; max-age=31556926; Path=/;`;

        updateSlider();
    })
});